import backdrops from './backdrops.json';
import costumes from './costumes.json';
import sounds from './sounds.json';
import sprites from './sprites.json';

const libraryAssetNames = new Set();

const collectAssetNames = value => {
    if (Array.isArray(value)) {
        value.forEach(collectAssetNames);
    } else if (value && typeof value === 'object') {
        if (typeof value.md5ext === 'string') {
            libraryAssetNames.add(value.md5ext);
        }
        Object.keys(value).forEach(key => collectAssetNames(value[key]));
    }
};

[backdrops, costumes, sounds, sprites].forEach(collectAssetNames);

const isLibraryAsset = asset => libraryAssetNames.has(`${asset.assetId}.${asset.dataFormat}`);
// The GUI bundle is embedded into the exam page on another port. Resolve from
// webpack's runtime public path so both the page and storage Workers fetch from
// the Scratch asset server instead of the exam server's origin.
// eslint-disable-next-line no-undef
const configuredAssetRoot = typeof window !== 'undefined' &&
    window.__EXAM_SCRATCH_CONFIG__ && window.__EXAM_SCRATCH_CONFIG__.scratchEditorUrl;
// Jest and other non-webpack consumers do not define webpack's runtime path.
// eslint-disable-next-line no-undef, camelcase
const webpackAssetRoot = typeof __webpack_public_path__ === 'undefined' ?
    'http://localhost/' : __webpack_public_path__; // eslint-disable-line no-undef, camelcase
const libraryAssetBase = typeof window !== 'undefined' && window.__EXAM_SCRATCH_CONFIG__?.examMode === '1' ?
    new URL('/exam-scratch-static/library-assets/', window.location.origin).href :
    new URL('static/library-assets/', configuredAssetRoot || webpackAssetRoot).href;
const getLibraryAssetURL = md5ext => new URL(md5ext, libraryAssetBase).href;
const thumbnailFormats = new Set(['gif', 'jpg', 'jpeg', 'png', 'svg']);
const getLibraryThumbnailURL = md5ext => {
    const extension = md5ext.split('.').pop()
        .toLowerCase();
    if (!thumbnailFormats.has(extension)) return getLibraryAssetURL(md5ext);
    const filename = `${md5ext.slice(0, -(extension.length + 1))}.webp`;
    return new URL(`../library-thumbnails/${filename}`, libraryAssetBase).href;
};

export {
    getLibraryAssetURL,
    getLibraryThumbnailURL,
    isLibraryAsset
};
